(() => {
    const chatbot = document.getElementById('venchi-chatbot');

    if (!chatbot) {
        return;
    }

    const enabled = chatbot.dataset.enabled === 'true';
    const device = chatbot.dataset.device || 'all';
    const appId = chatbot.dataset.appId;

    if (!appId) {
        return;
    }

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    let shouldRender = enabled;

    if (!enabled) {
        switch (device) {
            case 'mobile':
                // exclude mobile => render only in desktop
                shouldRender = !isMobile;
                break;

            case 'desktop':
                // exclude desktop => render only in mobile
                shouldRender = isMobile;
                break;

            case 'all':
            default:
                // always exclude
                shouldRender = false;
                break;
        }
    }

    if (!shouldRender) {
        return;
    }

    const script = document.createElement('script');
    script.defer = true;
    script.id = "Microsoft_Omnichannel_LCWidget";
    script.src = "https://oc-cdn-public-eur.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js";
    script.dataset.appId = appId;
    script.dataset.lcwVersion = "prod";
    script.dataset.orgId = "9e61c47c-15ef-44e6-9fdd-26cc7f31a8fd";
    script.dataset.orgUrl = "https://m-9e61c47c-15ef-44e6-9fdd-26cc7f31a8fd.eu.omnichannelengagementhub.com";

    chatbot.appendChild(script);
})();